<template>
  <div>
    <LSButton v-if="isEditable" variant="outline" :size="size" type="secondary" @click="open">
      <template #icon>
        <EditIcon />
      </template>
    </LSButton>
    <EditClauseModal :show="isOpen" :section="section" @submit="handleSubmit" @close="close" />
  </div>
</template>

<script setup lang="ts">
import LSButton, { type ButtonSize } from '@/components/LSButton.vue'
import type { LegalDocumentSection } from '@/questionnaire/types'
import useEditClause from '@/utils/useEditClause'
import EditIcon from '@/assets/icons/24/pen.svg?component'
import EditClauseModal from './EditClauseModal.vue'

const props = defineProps<{
  section: LegalDocumentSection
  size: ButtonSize
}>()
const { open, isEditable, handleSubmit, close, isOpen } = useEditClause(props.section)
</script>
